export default __webpack_public_path__ + "fonts/color_ocean.d39caec438e1b16e5579315199fb0c48.png";